import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import { TPixelStatus } from "@/types/pixelStatus/pixelStatusTypes";
import { userSelector } from "@/redux/user/userSelector";

export const usePixelStatusTooltip = () => {
    const { pixelStatus } = useSelector(userSelector)
    const navigate = useNavigate();

    const goToPixel = () => {
        navigate('/pixel')
    }

    const PixelStatusColors: Record<TPixelStatus, string> = {
        notConnected: '#8A8884',
        process: '#D1ACF9',
        connected: '#85C66B',
        failed: '#FF3939'
    }

    const PixelStatusTexts: Record<TPixelStatus, string> = {
        notConnected: 'Pixel not connected',
        process: 'Collecting data',
        connected: 'Pixel connected properly !',
        failed: 'Installation failed'
    }

    return {
        pixelStatus,
        goToPixel,
        pixelStatusColor: PixelStatusColors[pixelStatus],
        pixelStatusText: PixelStatusTexts[pixelStatus]
    }
}